import React from 'react';
import PropTypes from 'prop-types';
import {testAttributes} from './Constants';
import * as styles from  './WpPage.module.scss';

const WpPage = ({
    title = null,
    editorial,
    articles = null
}) => (
    <div data-testid={testAttributes.WP_PAGE_ROOT} className={`${styles.wpPageRoot} QLD_ROOT`}>
        <div data-testid={testAttributes.WP_PAGE_LAYOUT} className={styles.wpPageLayout}>
            {title}
            {editorial}
        </div>
        <div data-testid={testAttributes.WP_PAGE_RELATED_GRID} className={styles.wpPageRelatedGrid}>
            {articles}
        </div>
    </div>
);
WpPage.propTypes = {
    /** H1 title of page, or null if H1 is embedded within another section */
    title: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    /** Content of page */
    editorial: PropTypes.oneOfType([
        PropTypes.arrayOf( PropTypes.any),
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    /** posts grid component including title and more */
    articles: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf( PropTypes.any ),
        PropTypes.object
    ])
}

export default WpPage;